import { render } from "./StockOrders.vue?vue&type=template&id=219eaca9&scoped=true"
import script from "./StockOrders.vue?vue&type=script&lang=js"
export * from "./StockOrders.vue?vue&type=script&lang=js"

import "./StockOrders.vue?vue&type=style&index=0&id=219eaca9&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-219eaca9"]])

export default __exports__